import {
  arrayOf, bool, number, string,
} from 'prop-types';
import React, { Component } from 'react';
import { View } from 'react-native';

import { ImageContent } from '../../../../components';
import { ENV, LAYOUT, THEME } from '../../../../reactor/common';
import { Motion, Slider, Text } from '../../../../reactor/components';
import styles from './Gallery.style';

const { IS_WEB } = ENV;
const { MOTION: { DURATION } } = THEME;

class Gallery extends Component {
  static propTypes = {
    images: arrayOf(string),
    motion: bool,
    rights: string,
    viewed: bool,
    visibility: number.isRequired,
  };

  static defaultProps = {
    images: [],
    motion: true,
    rights: undefined,
    viewed: undefined,
  };

  state = {
    width: LAYOUT.VIEWPORT.W,
  }

  render() {
    const {
      props: {
        images, motion, rights, viewed, visibility, ...inherit
      },
      state: { width },
    } = this;
    const { H, LANDSCAPE } = LAYOUT.VIEWPORT;
    const dataSource = images.map(uri => ({ uri, width, LANDSCAPE }));
    const sliderImageWidth = width * 0.8;

    return (
      <View
        onLayout={({ nativeEvent: { layout } }) => this.setState({ width: layout.width })}
        style={[
          styles.container,
          !IS_WEB && !LANDSCAPE && { height: H / 3.2 },
        ]}
      >
        {
          LANDSCAPE
            ? dataSource.map((props = {}, index) => (
              <Motion
                key={index} // eslint-disable-line
                delay={(DURATION / 5) * index}
                disabled={!motion || !LANDSCAPE}
                preset="pop"
                visible={viewed || visibility > 0.33}
              >
                <ImageContent
                  uri={props.uri}
                  style={{ width: width * 0.475, height: width * 0.3, margin: width * 0.01 }}
                />
              </Motion>
            ))
            : (
              <Slider
                dataSource={dataSource}
                item={({ data }) => <ImageContent {...data} style={{ width: sliderImageWidth }} />}
                itemWidth={sliderImageWidth}
                momentum
                navigation={false}
                style={styles.slider}
              />
            )
        }
        { rights && (
        <Text caption color={inherit.color} style={styles.rights}>
          {rights}
        </Text>
        ) }
      </View>
    );
  }
}

export default Gallery;
